import BaseView from 'picnic/core/views/Base';


const
	CLASS_FILLED = 'is-filled',
	SELECTOR_FIELDS = 'input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), textarea, select'
;


class View extends BaseView {
	render() {
		super.render();

		// Focus blocked inside slider
		// https://github.com/kenwheeler/slick/issues/2901
		const fields = this.$el[0].querySelectorAll(SELECTOR_FIELDS);
		for (let i = 0; i < fields.length; ++i) {
			this._toggleClass(fields[i]);
			fields[i].addEventListener('focus', this._onChange.bind(this));
			fields[i].addEventListener('blur', this._onChange.bind(this));
			fields[i].addEventListener('change', this._onChange.bind(this));
		}

		return this;
	}

	_toggleClass(el) {
		if (el && el.classList) {
			if (el.value !== '') {
				el.classList.add(CLASS_FILLED);
			} else {
				el.classList.remove(CLASS_FILLED);
			}
		}
	}

	_onChange(event) {
		this._toggleClass(event.target);
		this.trigger('change', event);
	}
}

export default View;
